import type { Logger } from "@aws-lambda-powertools/logger";

let lambdaLogger;
if (!globalThis.window) {
  await import("@aws-lambda-powertools/logger")
    .then(({ Logger }) => {
      lambdaLogger = new Logger({
        serviceName: process.env.DD_SERVICE,
      });
    })
    .catch((e) => {
      console.error("Error loading logger", e);
      lambdaLogger = console;
    });
}

// probably not the best eay to do this - may want to rethink the whole logging system
const logger: Logger = lambdaLogger ?? (console as unknown as Logger);
export { logger };
